// extracted by mini-css-extract-plugin
module.exports = {"userInputContainer":"styles__userInputContainer--bj86F","userInputHeader":"styles__userInputHeader--YIfzM","userInput":"styles__userInput--1Q1M8"};